module.exports = __webpack_public_path__ + "static/media/heartFilled.6a58318e.png";